"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionServiceClientImpl = exports.AccessResponse = exports.AccessRequest = void 0;
var _m0 = __importStar(require("protobufjs/minimal"));
function createBaseAccessRequest() {
  return {
    userId: "",
    appIds: [],
    permission: "",
    token: ""
  };
}
exports.AccessRequest = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.userId !== undefined && message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.appIds !== undefined && message.appIds.length !== 0) {
      var _iterator = _createForOfIteratorHelper(message.appIds),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;
          writer.uint32(18).string(v);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (message.permission !== undefined && message.permission !== "") {
      writer.uint32(26).string(message.permission);
    }
    if (message.token !== undefined && message.token !== "") {
      writer.uint32(34).string(message.token);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAccessRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.userId = reader.string();
          break;
        case 2:
          message.appIds.push(reader.string());
          break;
        case 3:
          message.permission = reader.string();
          break;
        case 4:
          message.token = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      userId: isSet(object.userId) ? String(object.userId) : "",
      appIds: Array.isArray(object === null || object === void 0 ? void 0 : object.appIds) ? object.appIds.map(function (e) {
        return String(e);
      }) : [],
      permission: isSet(object.permission) ? String(object.permission) : "",
      token: isSet(object.token) ? String(object.token) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    message.userId !== undefined && (obj.userId = message.userId);
    if (message.appIds) {
      obj.appIds = message.appIds.map(function (e) {
        return e;
      });
    } else {
      obj.appIds = [];
    }
    message.permission !== undefined && (obj.permission = message.permission);
    message.token !== undefined && (obj.token = message.token);
    return obj;
  },
  create: function create(base) {
    return exports.AccessRequest.fromPartial(base !== null && base !== void 0 ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _a, _b, _c, _d;
    var message = createBaseAccessRequest();
    message.userId = (_a = object.userId) !== null && _a !== void 0 ? _a : "";
    message.appIds = ((_b = object.appIds) === null || _b === void 0 ? void 0 : _b.map(function (e) {
      return e;
    })) || [];
    message.permission = (_c = object.permission) !== null && _c !== void 0 ? _c : "";
    message.token = (_d = object.token) !== null && _d !== void 0 ? _d : "";
    return message;
  }
};
function createBaseAccessResponse() {
  return {
    appIds: []
  };
}
exports.AccessResponse = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.appIds !== undefined && message.appIds.length !== 0) {
      var _iterator2 = _createForOfIteratorHelper(message.appIds),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var v = _step2.value;
          writer.uint32(10).string(v);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAccessResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.appIds.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      appIds: Array.isArray(object === null || object === void 0 ? void 0 : object.appIds) ? object.appIds.map(function (e) {
        return String(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.appIds) {
      obj.appIds = message.appIds.map(function (e) {
        return e;
      });
    } else {
      obj.appIds = [];
    }
    return obj;
  },
  create: function create(base) {
    return exports.AccessResponse.fromPartial(base !== null && base !== void 0 ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _a;
    var message = createBaseAccessResponse();
    message.appIds = ((_a = object.appIds) === null || _a === void 0 ? void 0 : _a.map(function (e) {
      return e;
    })) || [];
    return message;
  }
};
var PermissionServiceClientImpl = /*#__PURE__*/function () {
  function PermissionServiceClientImpl(rpc, opts) {
    _classCallCheck(this, PermissionServiceClientImpl);
    this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || "PermissionService";
    this.rpc = rpc;
    this.hasAccess = this.hasAccess.bind(this);
  }
  _createClass(PermissionServiceClientImpl, [{
    key: "hasAccess",
    value: function hasAccess(request) {
      var data = exports.AccessRequest.encode(request).finish();
      var promise = this.rpc.request(this.service, "hasAccess", data);
      return promise.then(function (data) {
        return exports.AccessResponse.decode(new _m0.Reader(data));
      });
    }
  }]);
  return PermissionServiceClientImpl;
}();
exports.PermissionServiceClientImpl = PermissionServiceClientImpl;
function isSet(value) {
  return value !== null && value !== undefined;
}